import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * This component display a simple popup with an error message
 * @param {ErrorPopup.propTypes} props
 * @return {JSX.Element}
 */
export function ErrorPopup(props) {
    let title;
    if (props.title) {
        title = props.title;
    } else if (props.errorFromAPI) {
        title = `SAP Purchase Request cannot be generated:`;
    } else {
        title = `Please fill in the mandatory information before the Purchase Request is submitted:`;
    }

    return (
        <Dialog
            onClose={props.onClose}
            open={props.open}
            aria-labelledby="error-popup"
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: props.color || 'red', width: '20%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', justifyContent: 'center'}}>
                    <i className="material-icons" style={{color: 'white'}}>{props.icon || 'error'}</i>
                </div>
                <div>
                    <DialogTitle id="popup-title">{title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{props.text}</DialogContentText>
                        <ul>
                            {props.errorMessages.map((msg, idx) => (
                                <li key={msg + idx}>
                                    <DialogContentText id="error-popup-description" >
                                        {msg}
                                    </DialogContentText>
                                </li>
                            ))}
                        </ul>
                        {props.appEventCode &&
                            <div className={'dialog-secondary-text'}>
                                {`Error code: ${props.appEventCode}`}
                            </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.onClose}>
                            Ok
                        </Button>
                    </DialogActions>
                </div>
            </div>

        </Dialog>
    );
}

ErrorPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    errorMessages: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.arrayOf(PropTypes.array),
    ]).isRequired,
    errorFromAPI: PropTypes.bool,
    color: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string,
    text: PropTypes.string,
    appEventCode: PropTypes.string,
};
